<script lang="ts" setup>
import type { Order } from "@shopware-pwa/types";
import { Divider } from "~/components/clarity-ui/Divider";
import { Heading } from "~/components/clarity-ui/Heading";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import OrderLineItems from "~/templates/components/shop/account/OrderLineItems.vue";

export interface OrderSelectableItemsProps {
  order: Order;
}

const { order } = defineProps<OrderSelectableItemsProps>();

// todo: use formattedDate
const orderDate = computed(() =>
  order?.orderDate
    ? new Date(order?.orderDate ?? "").toLocaleDateString(
        (typeof navigator !== "undefined" && navigator.language) || "de-DE",
      )
    : "",
);
</script>

<template>
  <div class="grid grid-cols-2 gap-2 hyphens-auto text-sm xl:grid-cols-6">
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderHistory/dateOfOrder" />
      {{ orderDate }}
    </div>
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderHistory/status" />
      {{ order.deliveries?.[0]?.stateMachineState?.name }}
    </div>
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderHistory/paymentStatus" />
      {{ order?.transactions?.[0]?.stateMachineState?.name }}
    </div>
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderHistory/paymentMethod" />
      {{ order?.transactions?.[0]?.paymentMethod?.name }}
    </div>
    <div class="contents xl:flex xl:flex-col xl:items-start xl:gap-2">
      <CommonLabel class="font-medium" path="BWF/shop/account/orderHistory/shippingMethod" />
      {{ order?.deliveries?.[0]?.shippingMethod?.name }}
    </div>
  </div>

  <Divider class="mt-2 xl:my-0" />

  <div class="mt-2 flex flex-col gap-4">
    <Heading size="medium" tag="h3">
      <CommonLabel path="BWF/shop/account/orderHistory/returnArticles" />
    </Heading>
    <OrderLineItems :order="order" :selectable="order.lineItems?.length > 0" />
  </div>
</template>
